export const isPosAllowed = (profileData) =>
  profileData?.allowPointOfSale ?? profileData?.AllowPointOfSale ?? true;

/** True when SuperAdmin enabled Go Fatafat / marketplace for this company. */
export const isGoFatafatEnabled = (profileData) => {
  if (!profileData) return false;
  const raw =
    profileData.isOnlineMarketplaceEnabled ??
    profileData.IsOnlineMarketplaceEnabled ??
    profileData.isWebApp ??
    profileData.ISWebApp;
  if (typeof raw === "boolean") return raw;
  if (raw === 1 || raw === "1" || raw === "true" || raw === "True") return true;
  return false;
};

/** Sections hidden for online-only (no POS / Go Fatafat-only) companies. Reports stay allowed for marketplace. */
export const ONLINE_ONLY_BLOCKED_SECTIONS = [
  "dashboard",
  "customers",
  "purchase",
  "diningManagement",
];

/** POS-only report paths blocked for online-only companies.
 *  Sales Breakdown / By Products / Deal Performance stay allowed for marketplace. */
export const ONLINE_ONLY_BLOCKED_REPORT_PATH_PREFIXES = [
  "/report/customerreport",
  "/report/riderreport",
  "/report/zreport",
  "/report/purchasesupplierreport",
  "/report/requisitionreport",
  "/report/masterinventoryreport",
  "/report/staffactivitylogreport",
  "/report/pettyfloatcashreport",
  "/report/reconciliationreport",
  "/report/tablespent",
];

export const ONLINE_ONLY_BLOCKED_PATH_PREFIXES = [
  ...ONLINE_ONLY_BLOCKED_REPORT_PATH_PREFIXES,
  "/dashboard",
  "/customer",
  "/customergroup",
  "/role",
  "/branches",
  "/purchaseorder",
  "/supplier",
  "/requisition",
  "/diningareas",
  "/diningmanagement",
  "/servicearea",
  "/managedevices",
  "/printingreceipts",
  "/pettycash",
  "/team/staffshiftreport",
  "/team/staffworkreport",
  "/team/payouts",
  "/team/schedule",
  "/team/leave",
  "/recipes",
  "/batches",
];

export const isSectionAllowedForCompany = (profileData, sectionKey) => {
  if (isPosAllowed(profileData)) return true;
  return !ONLINE_ONLY_BLOCKED_SECTIONS.includes(sectionKey);
};

export const isOnlineOnlyBlockedPath = (pathname) => {
  const path = (pathname || "").toLowerCase();
  return ONLINE_ONLY_BLOCKED_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
};

export const isPathBlockedForCompany = (profileData, pathname) => {
  if (isPosAllowed(profileData)) return false;
  return isOnlineOnlyBlockedPath(pathname);
};

export const mergeCompanyCapabilities = (profileData, companyCapabilities) => {
  if (!companyCapabilities) return profileData;
  const allowPointOfSale =
    companyCapabilities.allowPointOfSale ??
    companyCapabilities.AllowPointOfSale;

  if (typeof allowPointOfSale !== "boolean") return profileData;

  return {
    ...(profileData || {}),
    allowPointOfSale,
    AllowPointOfSale: allowPointOfSale,
  };
};
